<div id="loaderContainer">
  <img src="assets/images/Variant2.svg" width="500" id="logo" />
  <div class="text">{{ 'LOAD_CONFIGURATION.VALIDATING' | translate }}</div>
  <div id="animationContainer">
    <div class="lds-roller">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
</div>
